import _curry1 from "./internal/_curry1.js";
import _has from "./internal/_has.js";
var toPairs = _curry1(function toPairs(obj) {
    var pairs = [];
    for (var prop in obj) {
        if (_has(prop, obj)) {
            pairs[pairs.length] = [prop, obj[prop]];
        }
    }
    return pairs;
});
export default toPairs;
